import { IPatentType } from '@pharmsnap/shared/types/patent'
import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { getAsyncListTippyConfig } from '../config'
import { BPatentTypeFetchListCard } from './BPatentTypeFetchListCard'
export const BPatentTypePopperListCard = defineComponent({
  name: 'BPatentTypePopperListCard',
  props: {
    ids: {
      type: Array as PropType<IPatentType[]>,
      required: true,
    },
  },
  render() {
    return (
      <PtPopper data={{ ids: this.ids }} tippyConfig={getAsyncListTippyConfig()} component={BPatentTypeFetchListCard}>
        {this.$slots.default}
      </PtPopper>
    )
  },
})
